import type { ICellRendererParams } from "ag-grid-community";

import type { ConstructorDocumentKit } from "../constructor-documents-page.lib";

/** Ячейка «Документов»: «17, 16 обязательных». */
export const DocumentKitDocumentsCell = (params: ICellRendererParams<ConstructorDocumentKit>) => {
  const kit = params.data;

  if (!kit) {
    return null;
  }

  return (
    <>
      {kit.documentsTotal}
      <span className="text-type-light">, {kit.documentsRequired} обязательных </span>
    </>
  );
};
